import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ARROW_LAYERS_COUNT = 5

export const UPGRADE_COST_LABEL = (
    <FormattedMessage
        id='building_card_image.upgrade_cost_label'
        defaultMessage='Модернизировать'
    />
)



// WEBPACK FOOTER //
// ./components/BuildingCardImage/constants.jsx